import { createFileRoute } from '@tanstack/react-router';
import { ContactPage } from '../features/contact';
import { staticHead } from '../lib/seo';

export const Route = createFileRoute('/contact')({
  head: () =>
    staticHead({
      pathname: '/contact',
      title: 'اتصل بنا',
      description: 'تواصل مع فريق تلي صافي للأخبار والإعلانات والشراكات.',
    }),
  component: ContactPage,
});
